import { ForumIcon } from './ForumIcon';

/**
 * author: Google
 * id 3AC84477-2308-4445-868C-9666AE25B054
 * name forum
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum.svg
 * tags
 */
export const QuestionAnswerIcon = ForumIcon;
export default QuestionAnswerIcon